// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import FormControl from '@mui/material/FormControl';
// Actions
import { setIsProtectedDescription } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';
import { Checkbox, FormControlLabel } from '@mui/material';

type Props = {
    circuit: Circuit | null
}

export function CircuitIsProtectedDescription(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const is_protected_description = useSelector((state: AppState) => state.circuit.is_protected_description);

    useEffect(() => {
        dispatch(setIsProtectedDescription(is_protected_description));
    }, [circuitData]);

    const onIsProtectedDescriptionChange = (event: { target: { checked: boolean; }; }) => {
        dispatch(setIsProtectedDescription(event.target.checked));
    };

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(setIsProtectedDescription(props.circuit.is_protected_description));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth variant={'outlined'}>
            <FormControlLabel control={<Checkbox checked={is_protected_description} onChange={onIsProtectedDescriptionChange} />}
                label={t('shared.protected-description')} />
        </FormControl>
    );
}

export default CircuitIsProtectedDescription;
